export default __webpack_public_path__ + "static/media/Four-in-one-sensor-Inactive_v1.da2f8bc8.svg";